/**
 * Ensures a trailing slash on all non-root pathnames for outbound navigation.
 * TEST/CMS 301-redirects `/customers` → `/customers/` and `/customers/123` →
 * `/customers/123/`; emitting the canonical form avoids an extra round trip.
 *
 * @param {string} pathname
 * @returns {string}
 */
export const canonicalRoutePath = (pathname) => {
  if (!pathname || typeof pathname !== 'string') {
    return pathname
  }
  const trimmed = pathname.trim()
  if (!trimmed || trimmed === '/') {
    return trimmed || '/'
  }
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  const withoutTrailing = withLeading.replace(/\/+$/, '') || '/'
  if (withoutTrailing === '/') {
    return '/'
  }
  return `${withoutTrailing}/`
}

/** @deprecated Use canonicalRoutePath */
export const canonicalPathForQuery = canonicalRoutePath

export default canonicalRoutePath
